import $ from 'jquery';

import whenDomReady from 'when-dom-ready';

export default async () => {

	let $body = $('body');

	console.log('Init Router');
	// console.log($body);

	whenDomReady(() => {
        if (!$body.hasClass('template-password')) {
            console.log(`not password page`);
        }
    });
};
